import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo } from 'react';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { safeParseJSON } from 'framework-listing-lib/utils/json';
import { useReadLocalStore, useWriteLocalStore } from '../../hooks/useLocalStore';
import useApplicationId from '../../hooks/useApplicationId';
function getStorageKey({
  objectTypeId,
  applicationId
}) {
  return `ListingLibFoldersColumns:${objectTypeId}:${applicationId}`;
}
export function useFetchPersistedFoldersColumns(t0) {
  "use memo";

  var _data$value;
  const $ = _c(10);
  const enabled = t0 === undefined ? true : t0;
  const objectTypeId = useObjectTypeId();
  const applicationId = useApplicationId();
  let t1;
  if ($[0] !== applicationId || $[1] !== objectTypeId) {
    t1 = getStorageKey({
      objectTypeId,
      applicationId
    });
    $[0] = applicationId;
    $[1] = objectTypeId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = !enabled;
  let t3;
  if ($[3] !== t2) {
    t3 = {
      skip: t2
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data,
    loading
  } = useReadLocalStore(t1, t3);
  data === null || data === void 0 || data.value;
  const t4 = (_data$value = data === null || data === void 0 ? void 0 : data.value) !== null && _data$value !== void 0 ? _data$value : null;
  let t5;
  if ($[5] !== t4) {
    t5 = safeParseJSON(t4, undefined);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const columns = t5;
  let t6;
  if ($[7] !== columns || $[8] !== loading) {
    t6 = {
      columns,
      loading
    };
    $[7] = columns;
    $[8] = loading;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
export function useSavePersistedFoldersColumns() {
  'use no memo';

  const objectTypeId = useObjectTypeId();
  const applicationId = useApplicationId();
  const [writeLocalStore] = useWriteLocalStore();
  return useCallback(columns => {
    return writeLocalStore({
      key: getStorageKey({
        objectTypeId,
        applicationId
      }),
      value: JSON.stringify(columns)
    });
  }, [writeLocalStore, objectTypeId, applicationId]);
}